import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { FormCreditorKeys } from '../Components/Forms/FormCreditor/types'
import { FormDebtorKeys } from '../Components/Forms/FormDebtor/types'
import { FormFinancingKeys } from '../Components/Forms/FormFinancing/types'
import { FormThirdGuarantorKeys } from '../Components/Forms/FormThirdGuarantor/types'
import { FormVehicleKeys } from '../Components/Forms/FormVehicle/types'
import isDisableToEditContract from '../Components/StepsForm/Utils/isDisableToEditContract'

interface Schema {
    id: FormVehicleKeys | FormFinancingKeys | FormCreditorKeys | FormDebtorKeys | FormThirdGuarantorKeys
}

export const disableUfFields = (
    typeContractBoolean: boolean,
    select: SelectBuildProps & Schema,
    section: 'vehicles' | 'financing' | 'creditor' | 'debtor' | 'terceiroGarantidor'
) => {
    const sectionId = `${section}.${select.id}`
    if (typeContractBoolean) {
        return isDisableToEditContract[sectionId]
    } else if (select.isDisable) {
        return select.isDisable
    }
}

export const UFpercentual = ['AC', 'SC']
export const UFconditional = ['RJ']
